import React from "react";
import {
	useJsApiLoader,
	GoogleMap,
	Marker,
	InfoBox,
	OverlayView,
} from "@react-google-maps/api";
import { motion } from "framer-motion";
const Map = ({ coordinates, mapStyles, icons, cityname, weather }) => {
	const { isLoaded } = useJsApiLoader({
		id: "google-map-script",
		googleMapsApiKey: "AIzaSyB8ymDKCt0F7mo6zmnKrdYmgoHKeaUt3y4",
	});

	return (
		<>
			<div className="map">
				{isLoaded && (
					<GoogleMap
						mapContainerStyle={mapStyles}
						center={coordinates}
						zoom={10}
						options={{
							mapTypeId: "terrain",
						}}
					>
						{/* <OverlayView position={coordinates} mapPaneName="overlayLayer" >
							<div
								style={{
									backgroundColor: "aqua",
									width: "fit-content",
									height: "fit-content",

								}}
							>
								abc
							</div>
						</OverlayView> */}
						<Marker position={coordinates} />
						<InfoBox position={coordinates}>
							<div
								style={{
									height: "auto",
									padding: "10px",
									width: "150px",
									backgroundColor: "rgba(255, 255, 255, 0.4)",
									textAlign: "center",
								}}
							>
								<img
									src={icons}
									alt="icons"
									style={{ height: "30px", width: "30px" }}
								/>
								<h1>{cityname}</h1>
								<h1>{weather}°C</h1>
							</div>
						</InfoBox>
					</GoogleMap>
				)}
			</div>
		</>
	);
};

export default Map;
